/**
 * A Norce date as epoch milliseconds, `NaN` when absent or unreadable.
 *
 * Norce sends WCF dates (`/Date(1788213600000+0000)/`), which `Date.parse`
 * cannot read; ISO strings are accepted too.
 */
export const parseNorceDate = (value?: string | null): number => {
	if (!value) return NaN;
	const wcf = /^\/Date\((-?\d+)/.exec(value);
	return wcf ? Number(wcf[1]) : Date.parse(value);
};
